"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFCExportContextProvider = void 0;
var React = require("react");
var editablelist_1 = require("../../interfaces/editablelist");
var urls_1 = require("../../urls");
var actionFilterContext_1 = require("../filter/actionFilterContext");
var IFCExportContext = React.createContext({
    filter: __assign({}, editablelist_1.emptyActionFilter),
    onExportClick: undefined,
});
exports.default = IFCExportContext;
var IFCExportContextProvider = function (props) {
    var onExportClick = function (filters) {
        var startIFCSpinner = function () {
            $('div#load_container_ifc').removeClass('d-none');
        };
        var stopIFCSpinner = function () {
            $('div#load_container_ifc').addClass('d-none');
        };
        poll_for_result((0, urls_1.resolve)(urls_1.Urls.ifc_export, props.project_id), filters.to_json(), function () { return startIFCSpinner(); }, function (data) { }, function () { return stopIFCSpinner(); }, function (error) {
            notification(error, { type: "error" });
            stopIFCSpinner();
        });
    };
    return (React.createElement(actionFilterContext_1.ActionFilterContextProvider, { project_id: props.project_id },
        React.createElement(actionFilterContext_1.default.Consumer, null, function (action_filter_context) {
            return React.createElement(IFCExportContext.Provider, { value: {
                    filter: action_filter_context.filter,
                    onExportClick: onExportClick,
                } }, props.children);
        })));
};
exports.IFCExportContextProvider = IFCExportContextProvider;
